export default __webpack_public_path__ + "static/se-banner-4044881844b6f59d29606c7d33c6dd43.jpg";